<div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
  <a class="nav-link"  data-toggle="pill" [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" role="tab"
     aria-controls="v-pills-home" aria-selected="true">Home</a>
  <a class="nav-link" data-toggle="pill" [routerLink]="['/languages']" [routerLinkActiveOptions]="{exact: false}" role="tab"
     aria-controls="v-pills-home" routerLinkActive="active" >Languages</a>
  <a class="nav-link" data-toggle="pill" [routerLink]="['/language-keys']" [routerLinkActiveOptions]="{exact: false}" role="tab"
     aria-controls="v-pills-home" routerLinkActive="active" >Language Keys</a>
</div>
